import { getAPIUrl } from "../config";

const API_URL = getAPIUrl();

const authedFetch = async (getAccessTokenSilently, path, options = {}) => {
  const token = await getAccessTokenSilently();
  const response = await fetch(`${API_URL}${path}`, {
    ...options,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
  });

  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    throw new Error(payload.error || `Request failed (${response.status})`);
  }

  if (response.status === 204) return null;
  return response.json();
};

export const fetchMenus = async (venueId, getAccessTokenSilently) => {
  const menu = await authedFetch(getAccessTokenSilently, `/api/v1/venues/${venueId}/menu`, {
    method: "GET",
  });
  return menu ? [menu] : [];
};

export const addCategory = async (venueId, newCategory, getAccessTokenSilently) =>
  authedFetch(getAccessTokenSilently, `/api/v1/venues/${venueId}/categories`, {
    method: "POST",
    body: JSON.stringify(newCategory),
  });

export const updateCategory = async (venueId, categoryId, updatedCategory, getAccessTokenSilently) =>
  authedFetch(getAccessTokenSilently, `/api/v1/venues/${venueId}/categories/${categoryId}`, {
    method: "PUT",
    body: JSON.stringify(updatedCategory),
  });

export const deleteCategory = async (venueId, categoryId, getAccessTokenSilently) =>
  authedFetch(getAccessTokenSilently, `/api/v1/venues/${venueId}/categories/${categoryId}`, {
    method: "DELETE",
  });

export const addItem = async (venueId, newItem, getAccessTokenSilently) =>
  authedFetch(getAccessTokenSilently, `/api/v1/venues/${venueId}/items`, {
    method: "POST",
    body: JSON.stringify(newItem),
  });

export const updateItem = async (venueId, updatedItem, getAccessTokenSilently) =>
  authedFetch(getAccessTokenSilently, `/api/v1/venues/${venueId}/items/${updatedItem.id}`, {
    method: "PUT",
    body: JSON.stringify(updatedItem),
  });

export const updateItemAvailability = async (venueId, itemId, isAvailable, getAccessTokenSilently) =>
  authedFetch(getAccessTokenSilently, `/api/v1/venues/${venueId}/items/${itemId}/availability`, {
    method: "PATCH",
    body: JSON.stringify({ isAvailable }),
  });

export const deleteItem = async (venueId, itemId, getAccessTokenSilently) =>
  authedFetch(getAccessTokenSilently, `/api/v1/venues/${venueId}/items/${itemId}`, {
    method: "DELETE",
  });

export const reorderCategories = async (venueId, categoriesWithOrder, getAccessTokenSilently) =>
  authedFetch(getAccessTokenSilently, `/api/v1/venues/${venueId}/categories/reorder`, {
    method: "PUT",
    body: JSON.stringify({ categories: categoriesWithOrder }),
  });

export const reorderItems = async (venueId, categoryId, itemsWithOrder, getAccessTokenSilently) =>
  authedFetch(getAccessTokenSilently, `/api/v1/venues/${venueId}/categories/${categoryId}/items/reorder`, {
    method: "PUT",
    body: JSON.stringify({ items: itemsWithOrder }),
  });

export const fetchModifierGroups = async (venueId, getAccessTokenSilently) =>
  authedFetch(getAccessTokenSilently, `/api/v1/venues/${venueId}/modifier-groups`, {
    method: "GET",
  });

export const createModifierGroup = async (venueId, payload, getAccessTokenSilently) =>
  authedFetch(getAccessTokenSilently, `/api/v1/venues/${venueId}/modifier-groups`, {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const updateModifierGroup = async (venueId, groupId, payload, getAccessTokenSilently) =>
  authedFetch(getAccessTokenSilently, `/api/v1/venues/${venueId}/modifier-groups/${groupId}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
